import React from 'react';

import { TitleWithDescription, LbDatePicker } from '@infoods/lifebase-ui';
import { useFormContext } from 'react-hook-form';
import { Moment } from 'moment';

import {
  ReadOnlyInput,
  ModeAwareInput,
} from '../../../../../../shared/components/form-components';
import { FormFieldsGrid } from '../../../FormFieldsGrid/FormFieldsGrid';
import { getRenderDate } from '../../utils/getRenderDate';
import { Mode } from '../../../../../../general-types';
import { ChallengeFormValues } from '../../../../../interfaces/ChallengeFormValues';

type RegistrationDatesSectionProps = {
  mode: Mode;
  registrationMaxStartDate: Moment | undefined;
};

export const RegistrationDatesSection = ({
  mode,
  registrationMaxStartDate,
}: RegistrationDatesSectionProps) => {
  const { control } = useFormContext<ChallengeFormValues>();

  const generalInputProps = {
    size: 'small',
    variant: 'standard',
  } as const;

  return (
    <FormFieldsGrid mode={mode}>
      <TitleWithDescription
        title="Registration Dates"
        titleFont="body-14-bold"
        description="Set the time frame for participant sign-up."
      />
      <ModeAwareInput
        mode={mode}
        control={control}
        name="importantDates.registrationStartDate"
        label="Registration Start Date"
        renderValue={getRenderDate}
        renderEdit={(props) => (
          <LbDatePicker
            {...generalInputProps}
            {...props}
            maxDate={registrationMaxStartDate}
            rules={{ required: 'Registration Start Date is required' }}
          />
        )}
      />
      <ReadOnlyInput
        control={control}
        name="importantDates.registrationEndDate"
        label="Registration End Date"
        renderValue={getRenderDate}
      />
    </FormFieldsGrid>
  );
};
